export const THUMBNAIL_SIZE_GRID = 93;
export const THUMBNAIL_SIZE_LIST = 55;
